"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import Image from "next/image";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useDropContent } from "./useDropContent";
import DropLoading from "./DropLoading";
import DropNotFound from "./DropNotFound";
import ContentDisplay from "./ContentDisplay";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
interface WaveDropReplyProps {
  readonly dropId: string;
  readonly dropPartId: number;
  readonly maybeDrop: ApiDrop | null;
  readonly onReplyClick: (serialNo: number) => void;
}

/**
 * Component to display a reply in a wave drop
 */
export default function WaveDropReply(t0) {
  const $ = _c(8);
  const {
    dropId,
    dropPartId,
    maybeDrop,
    onReplyClick
  } = t0;
  const {
    drop,
    content,
    isLoading
  } = useDropContent(dropId, dropPartId, maybeDrop);
  let t1;
  if ($[0] !== content || $[1] !== drop || $[2] !== isLoading || $[3] !== onReplyClick) {
    t1 = () => {
      if (isLoading) {
        return <DropLoading />;
      }
      if (!drop?.author.handle) {
        return <DropNotFound />;
      }
      return <div className="tw-flex tw-w-full tw-min-w-0 tw-items-center tw-gap-x-1.5"><div className="tw-relative tw-z-10 tw-h-6 tw-w-6 tw-flex-shrink-0 tw-overflow-hidden tw-rounded-md tw-bg-iron-800">{drop.author.pfp ? <Image src={resolveIpfsUrlSync(drop.author.pfp)} alt={`${drop.author.handle}'s avatar`} fill={true} sizes="24px" className="tw-rounded-md tw-bg-transparent tw-object-contain" /> : <div className="tw-h-full tw-w-full tw-rounded-md tw-bg-iron-900 tw-ring-1 tw-ring-inset tw-ring-white/10" />}</div><div className="tw-min-w-0 tw-flex-1"><p className="tw-mb-0 tw-flex tw-min-w-0 tw-items-center xl:tw-pr-24"><Link href={`/${drop.author.handle}`} className="tw-mr-1 tw-flex-shrink-0 tw-text-sm tw-font-medium tw-text-iron-200 tw-no-underline tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-500">{drop.author.handle}</Link><ContentDisplay content={content} onClick={() => onReplyClick(drop.serial_no)} className="tw-min-w-0 tw-flex-1 tw-overflow-hidden" textClassName="tw-min-w-0 tw-overflow-hidden" /></p></div></div>;
    };
    $[0] = content;
    $[1] = drop;
    $[2] = isLoading;
    $[3] = onReplyClick;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const renderDropContent = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-absolute tw-left-5 tw-top-2.5 tw-w-6 tw-cursor-pointer tw-rounded-tl-[12px] tw-border-0 tw-border-l-[1.5px] tw-border-t-[1.5px] tw-border-solid tw-border-iron-700" style={{
      height: "calc(100% - 3px)"
    }} />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== renderDropContent) {
    t3 = <div className="tw-relative tw-mb-3" data-text-selection-exclude="true">{t2}<div className="tw-ml-[52px] tw-flex tw-items-center tw-gap-x-1.5"><div data-testid="wave-drop-reply-fixed-container" className="tw-h-[24px] tw-min-h-[24px] tw-max-h-[24px] tw-flex tw-w-full tw-items-center tw-overflow-hidden">{renderDropContent()}</div></div></div>;
    $[6] = renderDropContent;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}